module.exports = __webpack_public_path__ + "assets/fonts/Roboto-Medium.ttf";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/Roboto-Medium.ttf
// module id = 409
// module chunks = 0